import React, { useContext, useMemo, useState } from 'react';
import { t } from '../../../../types/translation/Translator';
import { TranslationKey } from './../../../../types/translation/TranslationKey';
import { ContactContext } from '../../../../context/ContactContext';
import { Contact } from '../../../../types/contact';
import { useNavigate } from 'react-router-dom';
import { CompanyRoleAssignmentContext } from '../../../../context/CompanyRoleAssignmentContext';
import SearchBarWithFilter from '../../../../VentoryUI/components/common/SearchBarWithFilter';
import Table from '../../../components/Table';
import { ContactFilter } from '../../../../VentoryUI/components/filters/ContactFilter/ContactFilter';
import { Routing } from '../../../../util/routes.util';
import { CreateButton } from '../../../components/Button';
import CreateContactModal from './Modals/CreateContactModal';

export default function ContactOverviewPane() {
  const navigate = useNavigate();

  const { contacts, contactsLoading } = useContext(ContactContext);
  const { isAdmin } = useContext(CompanyRoleAssignmentContext);

  const [openCreateModal, setOpenCreateModal] = useState<boolean>(false);

  const [items, setItems] = useState([...contacts.values()]);

  const headers = [
    {
      key: 'name',
      name: 'Name',
      text: (item: Contact) => item.name,
    },
  ];

  const allItems = useMemo(() => {
    return [...contacts.values()];
  }, [contacts]);

  const filter = new ContactFilter();

  return (
    <div className='flex flex-grow flex-col gap-4'>
      <CreateContactModal open={openCreateModal} setOpen={setOpenCreateModal} />
      <div className='flex justify-between gap-2'>
        <SearchBarWithFilter
          loading={contactsLoading}
          placeholder={t(TranslationKey.filterContacts).singular.label}
          items={allItems}
          setItems={setItems}
          filter={filter}
        />
        <div className='flex gap-1'>{isAdmin ? <CreateButton onClick={() => setOpenCreateModal(true)} /> : null}</div>
      </div>
      <Table
        loading={contactsLoading}
        items={items}
        totalItemCount={allItems.length}
        headers={headers}
        onClick={item => navigate(Routing.operations.contacts.update(item.id))}
        filter={filter}
      />
    </div>
  );
}
